import { Button, SelectChangeEvent } from "@mui/material";
import { Checkbox, Grid, Paper, MenuItem, Select } from "@mui/material";
import { useState, useEffect, useCallback, useContext, Suspense, useMemo, SetStateAction } from "react";
import { CustomInput, CustomSelectInput } from "../../../../../../shared/CustomInput";
import { CoveredDependents } from "../../../../../../shared/enrollment/coveredDependents";
import PlanActions from "../../../../../../shared/enrollment/planActions/PlanActions";
import PlanHeader from "../../../../../../shared/enrollment/planCode/PlanHeader";
import { AuthContext, GroupOwnerContext, PaycheckContext, ThemeContext } from "../../../../../../../contexts";
import { CoverageDetails } from "../../../../../../shared/enrollment";
import { useHistory, useLocation } from "react-router-dom";
import { dateTimeZoneConverter, manualDateComparator } from "../../../../../../../utils/commonFunctions/date";

import LinkIcon from "@mui/icons-material/Link";

import { PlanFormProps } from "../../../../../../../types/components/enrollmentProps.types";
import { getHealthPlanEligibleDependents } from "../../../../../../../utils/commonFunctions/groupEnrollment/eligibleDependents";
import { Member } from "../../../../../../../types/employee.types";
import { BeazleyPlanDetails, PremiumRateCoverage } from "../../../../../../../types/plan.types";
import { numberToDollarStr } from "../../../../../../../utils/commonFunctions/dollar";
import { CommonDetails, CoverageCode, StandardDetails } from "../../../../../../../types/enrollment.types";
import { RELATIONSHIP } from "../../../../../../../constants/relationship";
import { AddEnrollmentPayload } from "../../../../../../../utils/api/enrollment/enrollment";
import { api } from "../../../../../../../utils/api";
import { EligiblityDialogProps } from "../../../../../../../types/components/eligiblityDialogProps.types";
import { generateHealthPlanWaiveEnrollmentPayload } from "../../../../../../../utils/commonFunctions/groupEnrollment/enrollment";
import { CustomFormDialogType, CustomWaiveForm } from "../../../../../../../types/components/dialogProps.types";
import { LazyCustomFormDialog, LazyCustomWaiveFormDialog } from "../../../../../../shared";
import { getCurrentDate } from "../../../../../../../utils/commonFunctions/date";
import EligiblityDialog from "../../../../../VEBEnrollment/eligiblityDialogs/EligiblityDialog";
import {
	Health_Plan_Brochure_SBC,
	PanhanleNewBlackLogo,
	PFBHealthPlanBrochure,
	ProgressiveLabsPlanDesign_Enrollment
} from "../../../../../../../assets";

import "./panhandleForm.css";
import { dollarize } from "../../../../../../../utils/commonFunctions/dollarize";
import { trackPromise } from "react-promise-tracker";
import { WaiveCoverageFormType } from "../../../../../../../types/waiveDialogForm.types";
import { generateProgressiveLabsHealthPlanWaiveEnrollmentPayload } from "../../../../../../../utils/commonFunctions/ProgressiveLabsEnrollment/ProgressiveLabsCoreEnrollment/ProgressiveLabsCoreEnrollment";
import SwitchButton from "../../../../../../shared/toggleButton/ToggleButton";
import { translate } from "../../../../../../../constants/spanishEnglish";
import { premiumMap } from "../../../../../../../constants/panhandlePremiumAmount/panhandleAmount";

const PanHandleForm = ({
	dependents,
	openEnrollment,
	getEnrollmentInitData,
	isActiveEnrollment
}: PlanFormProps): JSX.Element => {
	const [waiveReason, setWaiveReason] = useState("");
	const [enrollmentStandardDetails, setEnrollmentStandardDetails] = useState<StandardDetails[]>([]);
	const [eligibleDependents, setEligibleDependents] = useState<Member[]>([]);
	const [coverageDetails, setCoverageDetails] = useState<any[]>([]);
	const [employeePremium, setEmployeePremium] = useState<number>(0);
	const [coveredDependents, setCoveredDependents] = useState<Member[]>([]);
	const { theme } = useContext(ThemeContext);
	const [dependentPremium, setDependentPremium] = useState<number>(0);
	const [isToggled, setIsToggled] = useState<boolean>(false);
	const [totalPremium, setTotalPremium] = useState<number>(0);
	const [customFormDialogProps, setCustomFormDialogProps] = useState<CustomWaiveForm>();
	const [combinedTotalPremium, setCombinedTotalPremium] = useState(0);
	const { member } = useContext(AuthContext);
	const { paycheck } = useContext(PaycheckContext);
	const { groupOwner } = useContext(GroupOwnerContext);

	const location = useLocation();
	const history = useHistory();
	const [enrollTelehealthConfirmation, setEnrollTelehealthConfirmation] = useState<any>({
		is_telehealth: true
		// another_group_insurance: null
	});
	const [isAgreeTerms, setIsAgreeTerms] = useState<boolean>(false);
	const [waiveCoverageForm, setWaiveCoverageForm] = useState<WaiveCoverageFormType>({
		waive_reason: "",
		other_waive_coverage: "",
		waive_employee_cost: false
	});
	const [submitWaiveFormStatus, setSubmitWaiveFormStatus] = useState<boolean>(false);
	const [eligiblityDialogProps, setEligiblityDialogProps] = useState<EligiblityDialogProps | any>({
		openDialog: false,
		handleCloseEligiblityDialog: () =>
			setEligiblityDialogProps(
				Object.assign({}, eligiblityDialogProps, {
					openDialog: false
				})
			),
		eligibleDependents: [],
		ineligibleDependents: [],
		ineligibleRelationshipDependents: [],
		groupPlanName: "ProgressiveLabs Health Plan"
	});
	const [subPlan, setSubPlan] = useState<string>("High Deductible Health Plan");

	const [coverageLevelPlanInputs, setCoverageLevelPlanInputs] = useState<{
		coverage: null | string;
		coverage_level: null | string;
		isRiderAdded: boolean;
	}>({
		coverage: null,
		coverage_level: null,
		isRiderAdded: false
	});

	const [language, setLanguage] = useState<"en" | "es">("en");

	/* eslint-disable arrow-parens */
	const handleToggle = () => {
		setIsToggled((prev) => !prev);
		setLanguage((prevLang) => (prevLang === "en" ? "es" : "en"));
	};

	const handleChangeIsAgreeTerms = useCallback(
		(event: any) => {
			const { checked } = event.target;

			setIsAgreeTerms(checked);
		},
		[isAgreeTerms]
	);
	// console.log("Current Language:", language);

	const handleChangeOtherInsurance = useCallback(
		(event: any) => {
			const { name, value, checked } = event.target;

			if (name === "is_telehealth") {
				setEnrollTelehealthConfirmation(Object.assign({}, enrollTelehealthConfirmation, { [name]: checked }));
				// console.log("Console Check---->", enrollTelehealthConfirmation);
			} else {
				setEnrollTelehealthConfirmation(Object.assign({}, enrollTelehealthConfirmation, { [name]: value }));
			}
		},
		[enrollTelehealthConfirmation]
	);

	const urlSearchParams: URLSearchParams = useMemo(() => new URLSearchParams(location.search), [location.search]);

	// console.log("waive form state", waiveCoverageForm);

	const handleWaiveEnrollment = useCallback(async () => {
		if (member === null || openEnrollment === null) {
			return;
		}
		const { standardDetails, commonDetails } = generateProgressiveLabsHealthPlanWaiveEnrollmentPayload(
			member,
			openEnrollment,
			waiveCoverageForm
		);

		if (isActiveEnrollment) {
			// console.log("isActiveEnrollment", isActiveEnrollment);
			commonDetails.enrollment_status = "WAIVED - WAITING FOR APPROVAL";
			// debugger;
		}

		// console.log("Waive Coverage Payloadsss", waiveCoverageForm);
		const enrollmentPayload: AddEnrollmentPayload = {
			standard_details: standardDetails,
			common_details: { ...commonDetails, agent_id: groupOwner && groupOwner._id ? groupOwner._id : null }
		};

		// console.log("PAYLOAD_CHECK--->", enrollmentPayload);
		const response = await api.enrollment.addPlEnrollment(enrollmentPayload);
		const step = urlSearchParams.get("step");
		if (response) {
			getEnrollmentInitData(false);
		}
		history.push(`?step=${step}&stage=2`);
	}, [getEnrollmentInitData, history, member, openEnrollment, urlSearchParams, waiveCoverageForm]);

	const handleWaiveReasonChange = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
		const { value, name, checked, type } = event.target;

		setWaiveCoverageForm((prevValue: any) => {
			return {
				...prevValue, // Using spread operator for a shallow copy
				[name]: type === "checkbox" ? checked : value
			};
		});
	}, []);

	const handleWaiveSubmition = useCallback(
		(waiveCoverageForm: WaiveCoverageFormType) => {
			setCustomFormDialogProps(
				Object.assign({}, customFormDialogProps, {
					openDialog: false
				})
			);
			handleWaiveEnrollment();
		},
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[customFormDialogProps, waiveCoverageForm]
	);

	const handleWaiveSubmitClick = useCallback(() => {
		setSubmitWaiveFormStatus((prevValue: any) => !prevValue);
	}, []);

	const handleWaiveButtonClick = useCallback(() => {
		setCustomFormDialogProps(
			Object.assign({}, customFormDialogProps, {
				openDialog: true,
				title: "Waivers Coverage Form",
				description:
					"The Group Health Plan has been offered to me and after seriously considering benefits I have decided not to enroll myself or my dependents in the Plan. I understand that i and my dependents must wait until the next open enrollment period unless a change of family and/or job status occur",

				inputFields: [
					{
						label: "Coverage Elsewhere",
						name: "waive_reason",
						type: "textfield",
						onChange: handleWaiveReasonChange,
						value: waiveCoverageForm.waive_reason,
						placeholder: "Name of carrier"
					},
					{
						label: "Employee Cost",
						name: "waive_employee_cost",
						type: "checkbox",
						onChange: handleWaiveReasonChange,
						value: waiveCoverageForm.waive_employee_cost,
						placeholder: ""
					},
					{
						label: "Other",
						name: "other_waive_coverage",
						type: "textfield",
						onChange: handleWaiveReasonChange,
						value: waiveCoverageForm.other_waive_coverage,
						placeholder: "State the other reason"
					}
				],
				actions: [
					{
						label: "Cancel",
						callback: () =>
							setCustomFormDialogProps(
								Object.assign({}, customFormDialogProps, {
									openDialog: false
								})
							)
					},
					{
						label: "Yes",
						callback: () => handleWaiveSubmitClick()
					}
				]
			})
		);
	}, [customFormDialogProps, handleWaiveReasonChange, handleWaiveSubmitClick, waiveCoverageForm]);

	const handleDialogClose = () => {
		setCustomFormDialogProps(
			Object.assign({}, customFormDialogProps, {
				openDialog: false
			})
		);
	};

	const handleSelectDependent = useCallback((event: React.ChangeEvent<HTMLInputElement>, dependent: Member) => {
		const { checked } = event.target;
		if (checked === true) {
			setCoveredDependents((prevCoveredDependents: Member[]) =>
				Object.assign([], [...prevCoveredDependents, dependent])
			);
		} else {
			setCoveredDependents((prevCoveredDependents: Member[]) => {
				const _selectedDependents = prevCoveredDependents.filter(
					(selectedDependent: Member) => dependent.SSN !== selectedDependent.SSN
				);
				return _selectedDependents;
			});
		}
	}, []);

	const getPremiumAmount = useCallback(
		(premiumRateCoverage: PremiumRateCoverage): string => {
			let premiumAmount = "";
			if (paycheck) {
				if (premiumRateCoverage.premium_type === "FIXED") {
					premiumAmount =
						(paycheck.pay_frequency === "BIWEEKLY"
							? premiumRateCoverage.weekly_premium
							: premiumRateCoverage.monthly_premium) + "";
					premiumAmount = `${numberToDollarStr(Number(premiumAmount))}`;
				} else if (premiumRateCoverage.premium_type === "PERCENTAGE") {
					premiumAmount =
						(paycheck.pay_frequency === "BIWEEKLY"
							? premiumRateCoverage.weekly_premium
							: premiumRateCoverage.monthly_premium) + "";
					premiumAmount = premiumAmount + "%";
				}
			}
			return premiumAmount;
		},
		[paycheck]
	);
	const [selectedCoverageLevel, setSelectedCoverageLevel] = useState<string>("High Deductible Health Plan");

	const getCoverageDetails = useCallback(() => {
		const _coverageDetails: any[] = [];
		if (openEnrollment === null || paycheck === null) {
			return;
		}

		const premiums = premiumMap[subPlan];
		const paymentFrequency = "biweekly";

		const {
			plan: { coverage }
		} = openEnrollment;

		// console.log("COVERAGE_CHECK___>", coverage);

		if (coverage.EE.active === true) {
			_coverageDetails.push({
				coverage: `${translate[language].coverageEmployeeOnlyText}`,
				premiumAmount: premiums[paymentFrequency].EE
			});
		}
		if (coverage.ES.active === true) {
			_coverageDetails.push({
				coverage: `${translate[language].coverageForSpouseText}`,
				premiumAmount: premiums[paymentFrequency].ES
			});
		}
		if (coverage.EC.active === true) {
			_coverageDetails.push({
				coverage: `${translate[language].coverageChildText}`,
				premiumAmount: premiums[paymentFrequency].EC
			});
		}
		// if (coverage.ED.active === true) {
		_coverageDetails.push({
			coverage: `${translate[language].coverageForFamily}`,
			premiumAmount: premiums[paymentFrequency].ED
		});
		// }
		setCoverageDetails(Object.assign([], _coverageDetails));
	}, [selectedCoverageLevel, openEnrollment, paycheck, language, subPlan]);

	const getPremiumRateByFixed = useCallback(
		(basePayRate: number, coverageCode: PremiumRateCoverage): number | null => {
			if (paycheck === null) {
				return null;
			}
			let premiumAmount: number | null = null;
			if (paycheck.pay_frequency === "MONTHLY") {
				premiumAmount = coverageCode.monthly_premium as number;
			} else if (paycheck.pay_frequency === "BIWEEKLY") {
				premiumAmount = coverageCode.weekly_premium as number;
			}
			return premiumAmount;
		},
		[paycheck]
	);
	const getPremiumRateByFixedForBop = useCallback(
		(monthly_premium: number, weekly_premium: number): number | null => {
			if (paycheck === null) {
				return null;
			}
			let premiumAmount: number | null = null;
			if (paycheck.pay_frequency === "MONTHLY") {
				premiumAmount = monthly_premium;
			} else if (paycheck.pay_frequency === "BIWEEKLY") {
				premiumAmount = weekly_premium;
			}
			return premiumAmount;
		},
		[paycheck]
	);

	const getPremiumRateByPercentage = useCallback(
		(basePayRate: number, coverageCode: PremiumRateCoverage): number | null => {
			if (paycheck === null) {
				return null;
			}
			let premiumAmount: number | null = null;
			if (paycheck.pay_frequency === "MONTHLY") {
				premiumAmount = (basePayRate * ((coverageCode.monthly_premium as number) / 100)) as number;
				if (premiumAmount > (coverageCode.monthly_maximum_premium as number)) {
					premiumAmount = coverageCode.monthly_maximum_premium as number;
				} else if (premiumAmount < (coverageCode.monthly_minimum_premium as number)) {
					premiumAmount = coverageCode.monthly_minimum_premium as number;
				}
			} else if (paycheck.pay_frequency === "BIWEEKLY") {
				premiumAmount = (basePayRate * ((coverageCode.weekly_premium as number) / 100)) as number;
				if (premiumAmount > (coverageCode.weekly_maximum_premium as number)) {
					premiumAmount = coverageCode.weekly_maximum_premium as number;
				} else if (premiumAmount < (coverageCode.weekly_minimum_premium as number)) {
					premiumAmount = coverageCode.weekly_minimum_premium as number;
				}
			}
			return premiumAmount;
		},
		[paycheck]
	);

	const calculatePremiumByCoverage = useCallback(
		(basePayRate: number, coverageCode: PremiumRateCoverage): number | null => {
			if (openEnrollment === null || paycheck === null) {
				return null;
			}

			let premiumAmount: number | null;
			if (coverageCode.active === false) {
				alert("Member is not covered in this plan");
				return null;
			}
			if (coverageCode.premium_type === "PERCENTAGE") {
				premiumAmount = getPremiumRateByPercentage(basePayRate, coverageCode);
			} else if (coverageCode.premium_type === "FIXED") {
				premiumAmount = getPremiumRateByFixed(basePayRate, coverageCode);
			} else {
				alert("Invalid premium type");
				return null;
			}
			return premiumAmount;
		},
		[getPremiumRateByFixed, getPremiumRateByPercentage, openEnrollment, paycheck]
	);

	const calculatePremium = useCallback(() => {
		if (openEnrollment === null || paycheck === null) {
			return null;
		}

		const coveredChildren: Member[] = [];
		const childrenRelationships: string[] = [
			RELATIONSHIP.child,
			RELATIONSHIP.disabled_child,
			RELATIONSHIP.legal_custody_child,
			RELATIONSHIP.stepchild,
			RELATIONSHIP.court_ordered_dependent,
			RELATIONSHIP.grandchild
		];
		let coveredSpouse: Member | any = null;
		let basePayRate: number;
		if (paycheck?.pay_frequency === "BIWEEKLY") {
			basePayRate = paycheck.weekly_base_rate;
		} else if (paycheck?.pay_frequency === "MONTHLY") {
			basePayRate = paycheck.monthly_base_rate;
		} else {
			alert("Invalid Pay Frequency");
			return;
		}

		let employeePremium: number | null = 0;
		employeePremium = getPremiumRateByFixedForBop(premiumMap[subPlan].monthly.EE, premiumMap[subPlan].biweekly.EE);
		if (employeePremium === null) {
			return;
		}

		coveredDependents.forEach((coveredDependent: Member) => {
			if (childrenRelationships.includes(coveredDependent.relationship as string)) {
				coveredChildren.push(coveredDependent);
			} else if (coveredDependent.relationship === RELATIONSHIP.spouse) {
				coveredSpouse = coveredDependent;
			}
		});

		const coverageCode = coveredSpouse && coveredChildren.length !== 0 ? "EF" : coveredSpouse ? "ES" : "ECH";
		const standardDetails: StandardDetails[] = [];
		let _dependentPremium = 0;

		if (coveredDependents.length !== 0) {
			if (coveredSpouse !== null) {
				const premiumAmount = getPremiumRateByFixedForBop(
					premiumMap[subPlan].monthly.ES,
					premiumMap[subPlan].biweekly.ES
				);
				if (premiumAmount === null) {
					alert("Invalid Premium Amount");
					return null;
				}
				const spouseStandardDetails: StandardDetails = {
					member_object_id: coveredSpouse._id,
					coverage_code: "ES",
					member_SSN: coveredSpouse.SSN,
					premium_amount: premiumAmount,
					is_tobacco: false
				};
				standardDetails.push(spouseStandardDetails);
				_dependentPremium = premiumAmount;
			}
			if (coveredChildren.length !== 0) {
				coveredChildren.forEach((coveredChild: Member) => {
					const premiumAmount = getPremiumRateByFixedForBop(
						premiumMap[subPlan].monthly.EC,
						premiumMap[subPlan].biweekly.EC
					);
					if (premiumAmount === null) {
						alert("Invalid Premium Amount");
						return null;
					}
					const childStandardDetails: StandardDetails = {
						member_object_id: coveredChild._id,
						coverage_code: "EC",
						member_SSN: coveredChild.SSN,
						premium_amount: premiumAmount, // Update premium_amount here
						is_tobacco: false
					};
					standardDetails.push(childStandardDetails);
					_dependentPremium = premiumAmount;
				});
			}
			if (coveredSpouse !== null && coveredChildren.length !== 0) {
				const premiumAmount = getPremiumRateByFixedForBop(
					premiumMap[subPlan].monthly.ED,
					premiumMap[subPlan].biweekly.ED
				);
				if (premiumAmount === null) {
					alert("Invalid Premium Amount");
					return null;
				}
				_dependentPremium = premiumAmount;
			}

			// Update the state
			setEnrollmentStandardDetails([...standardDetails]);
			setDependentPremium(_dependentPremium);
		}

		if (coveredDependents.length !== 0) {
			setTotalPremium(_dependentPremium);
		} else {
			setTotalPremium(employeePremium);
		}

		setEmployeePremium(employeePremium);
	}, [calculatePremiumByCoverage, coveredDependents, openEnrollment, paycheck, subPlan]);

	// console.log("<<=======Total Premium======>>", totalPremium);
	// console.log("<<=======Employee Premium=====>>", employeePremium);
	// console.log("<<=======Dependent Premium=========>>", dependentPremium);

	const handleActivateButtonClick = useCallback(async () => {
		// console.log("before isagree");
		if (isAgreeTerms) {
			// console.log("after isagree", member, openEnrollment);
			if (member === null || openEnrollment === null) {
				return;
			}

			const currentDate = new Date() as unknown as string;
			const planStartDate = openEnrollment.plan.start_date; // -1 or 0
			const planDateComparison: number = manualDateComparator(planStartDate, currentDate);

			const effectiveDate = openEnrollment.plan.auto_approve
				? planDateComparison === -1 || planDateComparison === 0
					? getCurrentDate()
					: null
				: null;

			const healthPlanEnrollmentCommonDetails: CommonDetails = {
				agent_id: groupOwner && groupOwner._id ? groupOwner._id : null,
				location_number: member.location.location_number,
				location_name: member.location.location_name,
				group_number: member.group_number,
				group_name: member.group.name,
				plan_object_id: openEnrollment.plan._id,
				plan_code: openEnrollment.plan.plan_code,
				plan_name: openEnrollment.plan.plan_name,
				sub_plan: subPlan,
				base_plan_name: openEnrollment.plan.plan_name,
				insured_object_id: member._id,
				insured_SSN: member.SSN,
				writing_number: 0,
				unenrolled_reason: null,
				waive_reason: null,
				termination_reason: null,
				enrollment_date: getCurrentDate(),
				effective_date: effectiveDate,
				termination_date: null,
				open_enrollment_id: openEnrollment._id,
				total_premium: totalPremium,
				is_telehealth: enrollTelehealthConfirmation.is_telehealth,
				another_group_insurance: enrollTelehealthConfirmation.another_group_insurance
			};

			// This part is extra for Covered Dependent
			const childrenRelationships: string[] = [
				RELATIONSHIP.child,
				RELATIONSHIP.disabled_child,
				RELATIONSHIP.legal_custody_child,
				RELATIONSHIP.stepchild,
				RELATIONSHIP.court_ordered_dependent,
				RELATIONSHIP.grandchild
			];

			let coveredSpouse: Member | any = null;
			const coveredChildren: Member[] = [];
			coveredDependents.forEach((coveredDependent: Member) => {
				if (childrenRelationships.includes(coveredDependent.relationship as string)) {
					coveredChildren.push(coveredDependent);
				} else if (coveredDependent.relationship === RELATIONSHIP.spouse) {
					coveredSpouse = coveredDependent;
				}
			});

			const coverageCode =
				coveredSpouse === null && coveredChildren.length === 0
					? "EE"
					: coveredSpouse && coveredChildren.length !== 0
					? "EF"
					: coveredSpouse
					? "ES"
					: "ECH";

			// Extra Part ends here

			const updatedStandardDetails = enrollmentStandardDetails.map((detail) => {
				if (detail.coverage_code === "ES") {
					return {
						...detail,
						premium_amount: combinedTotalPremium
					};
				}
				if (detail.coverage_code === "EC") {
					return {
						...detail,
						premium_amount: combinedTotalPremium
					};
				}
				return detail;
			});

			const progressiveLabsHealthPlanEnrollmentPayload: AddEnrollmentPayload = {
				common_details: healthPlanEnrollmentCommonDetails,
				standard_details: [
					...updatedStandardDetails,
					{
						member_object_id: member._id,
						member_SSN: member.SSN,
						coverage_code: "EE",
						premium_amount: combinedTotalPremium,
						is_tobacco: false
					}
				]
			};

			// console.log("progressiveLabsHealthPlanEnrollmentPayload", progressiveLabsHealthPlanEnrollmentPayload);

			const healthPlanResponse = await trackPromise(
				api.enrollment.addBopEnrollment(progressiveLabsHealthPlanEnrollmentPayload)
			);

			if (healthPlanResponse) {
				const step = urlSearchParams.get("step");
				getEnrollmentInitData(false);
				history.push(`?step=${step}&stage=2`);
			}
		} else {
			alert("Please accept the Terms and Conditions!");
		}
	}, [
		enrollTelehealthConfirmation.another_group_insurance,
		enrollTelehealthConfirmation.is_telehealth,
		coveredDependents,
		employeePremium,
		enrollmentStandardDetails,
		getEnrollmentInitData,
		history,
		isAgreeTerms,
		member,
		openEnrollment,
		totalPremium,
		urlSearchParams
	]);

	const redirectBrochureDownloiad = () => {
		const pdfURL = PFBHealthPlanBrochure;
		const pdfTitle = "PFB_Health_Plan_Brochure";
		window.open(pdfURL, pdfTitle);
	};

	const getCombinedTotal = useCallback(() => {
		if (totalPremium !== null) {
			setCombinedTotalPremium(totalPremium);
		}
	}, [totalPremium]);

	const handleAddDependentClick = useCallback(() => {
		history.push("/home/add-family-member");
	}, [history]);

	// const handleCoverageLevelInputChange = (event: SelectChangeEvent) => {
	// 	const { name, value } = event.target as HTMLSelectElement;
	// 	setCoverageLevelPlanInputs(
	// 		Object.assign({}, coverageLevelPlanInputs, {
	// 			[name]: value
	// 		})
	// 	);
	// };

	const handleCoverageLevelInputChange = (event: SelectChangeEvent) => {
		const { value } = event.target as HTMLSelectElement;

		// Update the selected plan
		setSubPlan(value);
	};

	// console.log("CHECK__CHECK___>>>>", selectedCoverageLevel);

	useEffect(() => {
		if (openEnrollment) {
			const dependentCoverage = getHealthPlanEligibleDependents(dependents, openEnrollment.plan.coverage);
			setEligibleDependents(Object.assign([], dependentCoverage.eligibleDependents));
			getCoverageDetails();
			setEligiblityDialogProps((prevEligiblityDialogProps: EligiblityDialogProps) => {
				return Object.assign({}, prevEligiblityDialogProps, {
					openDialog: true,
					eligibleDependents: Object.assign([], dependentCoverage.eligibleDependents),
					ineligibleRelationshipDependents: Object.assign(
						[],
						dependentCoverage.ineligibleRelationshipDependents
					),
					ineligibleDependents: Object.assign([], dependentCoverage.ineligibleDependents)
				});
			});
		}
	}, [dependents, getCoverageDetails, openEnrollment]);

	useEffect(() => {
		getCombinedTotal();
		calculatePremium();
	}, [calculatePremium, coveredDependents.length, getCombinedTotal]);

	useEffect(() => {
		if (submitWaiveFormStatus && waiveCoverageForm) handleWaiveSubmition(waiveCoverageForm);

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [submitWaiveFormStatus, waiveCoverageForm]);

	return (
		<div className="health-benefit">
			{/* <div style={{ display: "flex", alignItems: "center", justifyContent: "", marginLeft: "120px" }}>
				<h2 style={{ fontSize: "15px" }}>Change Language:</h2>
				<SwitchButton checked={isToggled} onToggle={handleToggle} />
			</div> */}

			<Suspense fallback={<div />}>
				{customFormDialogProps ? (
					<LazyCustomWaiveFormDialog
						customFormDialogProps={customFormDialogProps}
						handleDialogClose={handleDialogClose}
						date={dateTimeZoneConverter(getCurrentDate()) as unknown as string}
					/>
				) : null}
			</Suspense>
			<Suspense fallback={<div />}>
				<EligiblityDialog eligiblityDialogProps={eligiblityDialogProps} />
			</Suspense>
			<div className="paper-form-container">
				<Paper className="theme-border-radius paper-container" elevation={1}>
					<PlanHeader
						planName={`${translate[language].healthPlanText}`}
						planCode={openEnrollment?.plan.plan_code}
					/>
					<div className="theme-plan-section-margin" />
					<div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
						<img src={PanhanleNewBlackLogo} alt="" width="30%" />
					</div>
					<div className="theme-plan-section-margin" />
					<Grid item xl={5} lg={5} md={5} sm={5} xs={6}>
						<div className="details-form-row">
							<div className="details-form-label  required">Coverage Level</div>
							<Select
								value={subPlan}
								input={<CustomSelectInput />}
								style={{ width: "40%" }}
								name="subPlan"
								onChange={(event: SelectChangeEvent) => handleCoverageLevelInputChange(event)}
							>
								{["High Deductible Health Plan", "Copay Health Plan"].map(
									(coverageLevel: string, index: number) => {
										return (
											<MenuItem value={coverageLevel} key={index}>
												{coverageLevel}
											</MenuItem>
										);
									}
								)}
							</Select>
						</div>
					</Grid>
					<CoverageDetails
						coverageDetails={coverageDetails}
						titleHeader={`${translate[language].healthPlanText}`}
						choosePlanText={translate[language].chooseText}
					/>
					<div className="theme-plan-section-margin" />
					{eligibleDependents.length > 0 ? (
						<CoveredDependents
							dependents={eligibleDependents}
							handleSelectDependent={handleSelectDependent}
						/>
					) : (
						<div className="grid-actions-container">
							<div className="grid-action-margin" />
							<Button
								variant="contained"
								className="plan-action-button"
								style={{
									float: "right",
									marginBottom: "1rem",
									color: theme.button.color,
									backgroundColor: theme.button.background_color
								}}
								onClick={handleAddDependentClick}
							>
								{translate[language].addDependentButtonText}
							</Button>
						</div>
					)}

					{/* <Grid className="grid-container" container columnSpacing={2}>
						<Grid container columnSpacing={2}>
							<Grid item xl={4} lg={4} md={4} sm={5} xs={6}>
								<div className="details-form-label  required">{translate[language].groupPlanText}</div>
							</Grid>
							<Grid item xl={3} lg={3} md={3} sm={5} xs={6}>
								<div className="details-form-row">
									<div className="details-form-label"></div>
								</div>
							</Grid>
							<Grid item xl={3} lg={3} md={3} sm={5} xs={6}>
								<div className="details-form-row">
									<div className="details-form-label"></div>
								</div>
							</Grid>
							<Grid item xl={2} lg={2} md={2} sm={2} xs={6}>
								<div className="details-form-row">
									<div className="details-form-label required align-center">
										{translate[language].premiumText}
									</div>
									<div className="show-premium"></div>
								</div>
							</Grid>
						</Grid>

						<Grid container columnSpacing={2}>
							<Grid item xl={5} lg={5} md={3} sm={5} xs={6}>
								<div style={{ display: "flex" }}>
									<div className="checkbox-label details-form-row">
										<div className="details-form-label">{translate[language].healthPlanText}</div>
									</div>
								</div>
							</Grid>
							<Grid item xl={5} lg={5} md={3} sm={5} xs={6}></Grid>
							<Grid item xl={2} lg={2} md={3} sm={2} xs={6}>
								<div className="details-form-row margin-top-minus-8">
									<div className="show-premium">$ {totalPremium}</div>
								</div>
							</Grid>
						</Grid>
					</Grid> */}

					<div className="theme-plan-section-margin" />

					{/* ============================================================== (PREMIUM AMOUNT) ========================================== */}

					<div className="theme-plan-inner-section-margin-2" />
					<Grid container className="theme-plan-inner-section-margin">
						<Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
							<div className="details-form-row">
								<div
									className="details-form-label theme-plan-total-premium align-right"
									style={{ color: theme.primary_color }}
								>
									{translate[language].totalPremiumText} :{" "}
									<span className="show-premium margin-adjust">
										{combinedTotalPremium == 0
											? "$0.00"
											: `$${combinedTotalPremium && combinedTotalPremium.toFixed(2)}`}
										{/* {totalPremium == 0 ? "$0.00" : `$${totalPremium && totalPremium.toFixed(2)}`} */}
									</span>
								</div>
							</div>
						</Grid>
					</Grid>

					<div className="theme-plan-option-content theme-plan-section-margin">
						<div className="telehealth-enrollment-container">
							<h2 className="telehealth-header">
								Any employee enrolling in either MEDICAL PLAN will have telehealth services provided at
								NO COST to the EMPLOYEE.
							</h2>
							<div className="telehealth-checkbox-wrapper">
								<Checkbox
									onClick={handleChangeOtherInsurance}
									name="is_telehealth"
									checked={enrollTelehealthConfirmation.is_telehealth}
									style={{ paddingLeft: 0, marginTop: 2 }}
								/>
								<p className="theme-plan-checkbox-label">
									<strong>
										{enrollTelehealthConfirmation.is_telehealth ? (
											<div className="terms-container">
												Yes, I want to be enrolled in the{" "}
												<p className="teledoc-health-plan-message">Teladoc Health plan</p> at no
												cost
											</div>
										) : (
											<div className="terms-container">
												No, I would like to waive my option for the{" "}
												<p className="teledoc-health-plan-message">Teladoc Health plan</p> at no
												cost
											</div>
										)}
									</strong>
								</p>
							</div>
						</div>
					</div>
					{/* <div>
						{enrollTelehealthConfirmation.is_telehealth ? (
							<CustomInput
								name="another_group_insurance"
								value={enrollTelehealthConfirmation.another_group_insurance}
								onChange={handleChangeOtherInsurance}
							/>
						) : null}
					</div> */}

					<div>
						<h3>{translate[language].signinText}</h3>
						<div className="herby-terms-conditions">
							{translate[language].herebyText},
							<div className="terms-container">
								<div>
									<LinkIcon className="link-icon" style={{ color: theme.primary_color }} />
								</div>
								<div>
									{translate[language].requestToEnrollText}{" "}
									{/* <a href="" onClick={redirectBrochureDownloiad}> */}
									{translate[language].benefitClickPlanText} {/* </a>{" "} */}
									{translate[language].aSummaryForRequestText}{" "}
									{/* <a href="" onClick={redirectBrochureDownloiad}> */}
									{translate[language].planSCoreClickText}
									{/* </a> */}
								</div>
							</div>
							<div className="terms-container">
								<div>
									<LinkIcon className="link-icon" style={{ color: theme.primary_color }} />
								</div>
								<div>
									{translate[language].reafirmText}{" "}
									<span
										onClick={redirectBrochureDownloiad}
										style={{
											color: "#0091ea",
											textDecoration: "none !important",
											fontWeight: "700",
											cursor: "pointer"
										}}
									>
										{translate[language].summaryPlanClickText}
									</span>{" "}
									{/* {translate[language].andText}{" "}
									<a href="" onClick={redirectBrochureDownloiad}>
										{translate[language].planDocumentClickText}
									</a> */}
								</div>
							</div>
							<div className="terms-container">
								<div>
									<LinkIcon className="link-icon" style={{ color: theme.primary_color }} />
								</div>
								<div>{translate[language].authorizeTheText}</div>
							</div>
							<div className="terms-container">
								<div>
									<LinkIcon className="link-icon" style={{ color: theme.primary_color }} />
								</div>
								<div>{translate[language].certifyText} </div>
							</div>
							<div className="terms-container">
								<div>
									<LinkIcon className="link-icon" style={{ color: theme.primary_color }} />
								</div>
								<div>{translate[language].iUnderstandText}</div>
							</div>
						</div>
					</div>

					<div className="theme-plan-section-margin" />
					{/* <div className="external-links">
						<div>
							<LinkIcon className="link-icon" style={{ color: theme.primary_color }} />
						</div>
						<div className="header">
							To Know More About The Benefits Offered,{" "}
							<a href="#" onClick={redirectBrochureDownloiad}>
								Click Here
							</a>
						</div>
					</div> */}
					<div className="theme-plan-option-content theme-plan-section-margin">
						<Checkbox
							checked={isAgreeTerms}
							onClick={handleChangeIsAgreeTerms}
							style={{ paddingLeft: 0 }}
						/>
						<p className="theme-plan-checkbox-label">
							<strong>{translate[language].secondCheckBoxContent}</strong>
						</p>
					</div>
					<div className="theme-plan-section-margin" />
					<Grid container className="theme-plan-section-margin">
						<Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
							<div className="details-form-row">
								<div className="details-form-label  required">{translate[language].signature}</div>
								<CustomInput value={member?.first_name + " " + member?.last_name} disabled />
							</div>
						</Grid>
						<Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
							<div className="details-form-row">
								<div className="details-form-label  required">{translate[language].date}</div>
								<CustomInput value={dateTimeZoneConverter(getCurrentDate())} disabled />
							</div>
						</Grid>
					</Grid>
					<div className="theme-plan-section-margin" />
					<PlanActions
						waiveButtonCallback={handleWaiveButtonClick}
						activateButtonCallback={handleActivateButtonClick}
					/>
				</Paper>
			</div>
		</div>
	);
};

export default PanHandleForm;
